import React from 'react';
import { Investment } from '@/types/investment';

interface FinancialsTableProps {
  investment: Investment;
}

const FinancialsTable: React.FC<FinancialsTableProps> = ({ investment }) => {
  const financials = [
    { label: 'Expected Return', value: investment.return },
    { label: 'Minimum Investment', value: `R ${investment.minInvestment.toLocaleString()}` },
    { label: 'Target Term', value: investment.schedule.targetTerm },
    { label: 'Offering Type', value: investment.structure.offeringType },
    { label: 'Asset Class', value: investment.type },
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-xl font-semibold text-card-foreground mb-6">Financials</h3>
      <div className="space-y-4">
        {financials.map((item, index) => (
          <div key={index} className="flex justify-between items-baseline">
            <span className="text-sm text-muted-foreground whitespace-nowrap pr-4">{item.label}</span>
            <span className="text-sm font-semibold text-right text-card-foreground whitespace-nowrap">
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FinancialsTable;
